import actions from './actions';

const initState = {
    loader: true,
    instanceDetails: '',
};

export default function scheduleInstanceReducer(state = initState, action) {
    switch (action.type) {
        case actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                instanceDetails: action.data
            };
        }
        case actions.CUSTOMER_SCHEDULEINSTANCE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false
            };
        }
        case actions.CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_START: {
            return initState
        }
        case actions.CLEAR_CUSTOMER_SCHEDULEINSTANCE_DETAILS_SUCCESS: {
            return initState
        }
        default:
            return state;
    }
}